import styled from 'styled-components'

export const Container = styled.div`
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp16}`};
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  box-shadow: 0px 4px 5px 0px rgba(17, 17, 17, 0.3);
`
